export const city_data = [
    
    {
        "img": "https://cdn.pixabay.com/photo/2021/04/06/11/22/hawa-mahal-6156123__340.jpg",
        "name": "Jaipur"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/bangaluru.jpg",
        "name": "Bengaluru"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/chennai-1.jpg",
        "name": "Chennai"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/coimbatore.jpg",
        "name": "Gurgaon"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/newdelhi.jpg",
        "name": "Delhi"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/mumbai.jpg",
        "name": "Mumbai"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/kolkata.jpg",
        "name": "Kolkata"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/hyderabad.jpg",
        "name": "Hyderabad"
    },
    {
        "img": "https://bookmypg.co.in/assets/front/images/chennai.jpg",
        "name": "Indore"
    }
]






// export const data = [
//     {
//         "id":"1",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"male",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city":"Indore"
        
//     },   
//     {
//         "id":"1",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"male",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city":"Indore"
        
//     },   {
//         "id":"2",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"male",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000"
        
//     },   {
//         "id":"3",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"male",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city" :"Chennai"
        
//     },   {
//         "id":"4",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"male",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city" :"Chennai"
        
//     },   {
//         "id":"5",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"male",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city" :"Chennai"
        
//     },   {
//         "id":"6",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",

//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"male",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city" :"Chennai"
        
//     },   {
//         "id":"7",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"female",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city" :"Chennai"
        
//     },   {
//         "id":"8",
//         "src1": "https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src2": "https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src3": "https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg", 
//         "src4": "https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg", 
//         "src5": "https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg", 
//         "src6": "https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
//         "src7":"https://bookmypg.co.in/storage/property/medium/2022/11/900ba6301ef8db98d3f6f847951a21870948583.jpeg",
//         "src8":"https://bookmypg.co.in/storage/property/medium/2022/11/56bc7e3a32504ad12d092577bce52e630702195.jpeg",
//         "src9":"https://bookmypg.co.in/storage/property/medium/2022/11/d91f65679b5593abb0b4f1345d4b35b50792733.jpeg",
//         "src10":"https://bookmypg.co.in/storage/property/medium/2022/11/bdbe4067bbb03ba0813b616652aa859e0347441.jpeg",
//         "src11":"https://bookmypg.co.in/storage/property/medium/2022/11/db035996faa3ffa415ad8fb7dea45b900035386.jpeg",
//         "src12":"https://bookmypg.co.in/storage/property/medium/2022/11/eb36e210ae8cd270d8bb7d6b4a18e8cc0660464.jpeg",
        
//         "pg_name":"Sai Enclave Gents PG",
//         "Gender" :"unisex",
//         "Address":"no 10/4, Tiruneermalai Main Road, Angalamman Nagar, Sripuram, Chromepet, Chennai, Tamil Nadu, India",
//         "Price":"9000",
//         "city" :"Chennai"
        
//     }
    
// ]